import firebaseInstance from "../../../util/firebase";
import firebase from "firebase";
import router from "../../../router";
import axios from "axios";

export default {
  doShare(state, item) {
    axios.post("/doshare", { params: { format: "json", data: item} })
      .then(res => console.log('res1', res))
      .catch(err =>  console.log("err", err.response))
  },
  getTokenData(state, token) {
    return new Promise(async (resolve, reject) => {
      firebaseInstance
        .database()
        .ref("shareTokens/" + token)
        .once('value', snap => {
          var tokenData = snap.val();
          resolve(tokenData)
        });
    });
  },
  acceptProject(state, item) {
    return new Promise(async (resolve, reject) => {
      firebaseInstance
        .database()
        .ref("users/" + item.userID + "/myProjects/" + item.projectID)
        .set(item.role, () => {
          firebaseInstance
          .database()
          .ref("projects/" + item.projectID + '/users/' + item.userID)
          .set(item.role, () => {
            firebaseInstance
            .database()
            .ref("projectsFull/" + item.projectID + '/users/' + item.userID)
            .set(item.role, () => {
              console.log("project accepted");
              resolve(true)
            })
          })
        })
        .catch(error => {
          console.log("Error accept project", error);
          reject(error)
        });
    });
  },

  changeProjectStatus(state, item) {
    console.log("changeProjectStatus", item);
    firebaseInstance
      .database()
      .ref("projects/" + item.projectid + "/status")
      .set(item.status, () => {
        console.log("project status set");
        // state.commit('REMOVE_PROJECT', item.projectID)
        state.commit("UPDATE_PROJECT_STATUS", item);
      })
      .catch(error => {
        console.log("Error changeProjectStatus", error);
      });
  },
  deleteProjectTask(state, item) {
    console.log("delete project task", item);
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/moduleColumns/" + item.section)
      .once("value", snap => {
        var columns = snap.val();
        columns.splice(item.index, 1);
        // firebaseInstance.database().ref('projectsFull/' + item.projectid + '/moduleColumns/' + item.section).set(columns, () => {
        //   console.log('updated project tasks', columns)
        // }).catch(console.error)
      })
      .catch(console.error);
  },
  deleteProject(state, item) {
    console.log("delete project action");
    firebaseInstance
      .database()
      .ref("users/" + item.userID + "/myProjects/" + item.projectID)
      .remove(() => {
        console.log("project removed");
        state.commit("REMOVE_PROJECT", item.projectID);
      })
      .catch(error => {
        console.log("Error removing project", error);
      });
  },
  updateProjectRateContingency(state, item) {
    console.log("updateProjectRateContingency action", item);
    var data = {
      contingency: item.contingency,
      blendedRate: item.rate,
      dontNull: true
    };
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid)
      .update(data, () => {
        console.log("updated project");
        state.commit("UPDATE_CURRENT_PROJECT", data);
        // router.push('/project/' + projectKey)
      })
      .catch(error => {
        console.log("Error updating full project data", error);
      });
  },
  updateProjectName(state, item) {
    if (item) {
      console.log("updateProjectName action", item);
      var data = {
        name: item.name
      };
      firebaseInstance
        .database()
        .ref("projects/" + item.projectid)
        .update(data, () => {
          console.log("updated project");
          state.commit("UPDATE_CURRENT_PROJECT", data);
          state.commit("UPDATE_PROJECT_DETAILS", item);
          // router.push('/project/' + projectKey)
        })
        .catch(error => {
          console.log("Error updating full project data", error);
        });
    } else {
      console.log("item", item);
    }
  },
  async getMyProjects(state, item) {
    const projectDetailList = await Promise.all(
      Object.keys(item.projectList).map(async (_project) => {
        const projectDetail = await new Promise(async (resolve, reject) => {
          firebaseInstance
          .database()
          .ref("projects/" + _project)
          .once("value", snap => {
            const oneProjectInfo = snap.val();
            resolve({
                ...oneProjectInfo,
                projectID: _project
            })
          });
        })
        return projectDetail
      })
    )

    const projectFulllList = await Promise.all(
      Object.keys(item.projectList).map(async (_project) => {
        const projectFull =  await new Promise(async (resolve, reject) => {
          firebaseInstance
          .database()
          .ref("projectsFull/" + _project)
          .once("value", snap => {
            const oneProjectInfo = snap.val();
            resolve({
              ...oneProjectInfo,
              projectID: _project
            });
          });
        })
        return projectFull
      })
    )
    const reducedList = projectDetailList.reduce((acc, x) => {
      acc[x.projectID] = x
      return acc;
    }, {})
    state.commit("ADD_PROJECT_LIST", reducedList)
    const reducedFullList = projectFulllList.reduce((acc, x) => {
      acc[x.projectID] = x
      return acc;
    }, {})
    state.commit("ADD_PROJECT_FULL_LIST", reducedFullList)
  },
  showTooManyProjectsDialog(state, item) {
    state.commit("POPUP_TOO_MANY_PROJECTS", {});
    state.commit("SHOW_POPUP", item.projectID);
  },
  hideTooManyProjectsDialog(state, item) {
    state.commit("POPUP_TOO_MANY_PROJECTS_HIDE", {});
    state.commit("SHOW_POPUP", null);
  },
  duplicateProject({state, commit}, key) {
    let date = new Date().getTime();
    var projectFull = state.myProjectDetailsFull[key]
    var projectPartial = state.myProjectDetails[key]
    var projectKey = ''
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
    for (var i = 32; i > 0; --i) projectKey += chars[Math.floor(Math.random() * chars.length)]

    var myProjectsData = {
      [projectKey]: 'admin'
    }
    let projectData = {...projectPartial, created: date, name: `${projectPartial.name} copy`}
    firebaseInstance.database().ref('projects/' + projectKey).update(projectData, () => {
      firebaseInstance.database().ref('users/' + state.uid + '/myProjects').update(myProjectsData, () => {
        firebaseInstance.database().ref('projectsFull/' + projectKey).update(projectFull, () => {
          console.log('saved project')
          commit('ADD_PROJECT', {...projectData, projectID: projectKey})
          commit('ADD_PROJECT_FULL', {...projectFull, projectID: projectKey})
          router.push('/projectpricing/' + projectKey)
        }).catch((error) => {
          console.log('Error saving full project data', error)
        })
      }).catch((error) => {
        console.log('Error saving project data to user', error)
      })
    }).catch((error) => {
      console.log('Error saving project data', error)
    })
  },
  reopenComment(state, item) {
    console.log("reopenComment action", item);
    firebaseInstance
      .database()
      .ref(
        "projectsFull/" +
          item.projectid +
          "/comments/" +
          item.commentid +
          "/status"
      )
      .set("active", () => {
        console.log("reopenComment success");
      })
      .catch(error => {
        console.log("Error reopenComment", error);
      });
  },
  resolveComment(state, item) {
    console.log("resolveComment action", item);
    firebaseInstance
      .database()
      .ref(
        "projectsFull/" +
          item.projectid +
          "/comments/" +
          item.commentid +
          "/status"
      )
      .set("resolved", () => {
        console.log("resolveComment success");
      })
      .catch(error => {
        console.log("Error resolveComment", error);
      });
  },
  addTheComment(state, item) {
    console.log("addTheComment action", item);
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/comments")
      .push(item.comment, () => {
        console.log("addTheComment success");
      })
      .catch(error => {
        console.log("Error addTheComment", error);
      });
  },
  addTheCommentFromToken(state, item) {
    console.log("addTheCommentFromToken action", item);

    var data = item.comment;

    axios
      .post("/postCommentFromToken", {
        params: {
          format: "json",
          data
        }
      })
      .then(function(response) {
        console.log("RESPONSE 11", response, item.comment);
        state
          .dispatch("getProjectDetailsWithToken", { token: item.comment.token })
          .then(() => {
            console.log("after getProjectDetailsWithToken");
          });
      })
      .catch(function(error) {
        console.log("ERROR 11", error.response);
      })
      .then(function() {
        // always executed
      });
    // firebaseInstance.database().ref('projectsFull/' + item.projectid + '/comments').push(item.comment, () => {
    //   console.log('addTheCommentFromToken success')
    // }).catch((error) => {
    //   console.log('Error addTheCommentFromToken', error)
    // })
  },
  saveProjectInfo(state, item) {
    console.log("save project info action");
    var data = {
      name: item.name,
      type: item.type
    };
    firebaseInstance
      .database()
      .ref("projects/" + item.id)
      .update(data, () => {
        console.log("saved project info");
        // state.commit('ADD_PROJECT', {...projectData, projectID: projectKey})
      })
      .catch(error => {
        console.log("Error saving project info", error);
      });
  },
  getProjectDetailsWithToken(state, item) {
    var data = item.token;
    console.log('get project details from token')
    return axios
      .post("/sharedproject", {
        params: { format: "json", data }
      })
      .then(response => {
        var projectFull = response.data.projectFull;
        var projectPartial = response.data.projectPartial;
        var details = response.data.details;
        state.commit("LOAD_PROJECT_FULL_DETAILS", projectFull);
        state.commit("LOAD_PROJECT_PART_DETAILS", projectPartial);
        state.commit("PROJECT_FROM_TOKEN", details);
        return Promise.resolve(true);
      })
      .catch(function(error) {
        return Promise.reject(error.response);
      });
  },
  popupExportProjectData(state, item) {
    console.log("----->", item.show);
    state.commit("POPUP_EXPORT_PROJECT_DATA", item.show);
  },
  saveProjectImage: (state, item) => {
    console.log("saving project image item", item);
    // projectID, file
    firebaseInstance
      .storage()
      .ref("projects/" + item.projectID + "/images/" + item.file.name)
      .put(item.file)
      .then(snapshot => {
        console.log("Uploaded a blob or file!", snapshot);
        firebaseInstance
          .storage()
          .ref()
          .child("projects/" + item.projectID + "/images/" + item.file.name)
          .getDownloadURL()
          .then(url => {
            console.log("url", url);
            firebaseInstance
              .database()
              .ref("projects/" + item.projectID + "/image")
              .set(url)
              .then(() => {
                console.log("Company image path saved");
                var object = {
                  projectID: item.projectID,
                  image: url
                };
                state.commit("SAVE_PROJECT_IMAGE", object);
              })
              .catch(error => {
                console.log(error, "Error saving path to company image");
              });
          })
          .catch(error => {
            console.log(error, "Error getting company image");
          });
      });
  },
  setUserRole(state, item) {
    state.commit('SET_USER_ROLE', item);
  }
};
